document.addEventListener("DOMContentLoaded", function () {

  // FVスライダー（フェード切り替え）
  // ※Swiper未読込のページ（下層など）でエラーにならないようガード
  if (typeof Swiper !== "undefined" && document.querySelector(".fade_swiper .swiper")) {
    new Swiper(".fade_swiper .swiper", {
      loop: true,
      speed: 3000,
      effect: "fade",
      allowTouchMove: false,
      fadeEffect: { crossFade: true },
      autoplay: {
        delay: 2500,
      },
      pagination: {
        el: ".fv_pagination",
        clickable: true,
      },
      slidesPerView: 1,
    });
  }

  // よくあるご質問（アコーディオン開閉）※イベント委譲
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".faq_q");
    if (!btn) return;
    var item = btn.closest(".faq_item");
    if (!item) return;
    var isOpen = item.classList.toggle("is-open");
    btn.setAttribute("aria-expanded", isOpen);
  });

  /********************************************/
  /* のし・包装                               */
  /********************************************/
  // ※商品詳細（properties[〜]）とカート（attributes[単品商品：〜]）で name が異なるため、
  //   クラス＋name の末尾一致で判定して両方に対応させる

  var NOSHI_RADIO = '.noshi_radio_input[name$="のし]"]';   // 【のし】のラジオ（【包装】は含まない）
  var NOSHI_OKURINUSHI = '.noshi_input[name$="贈り主]"]';

  // .noshi 内の各パーツを取得
  function getNoshiParts(noshi) {
    var omotegaki = noshi.querySelector(".noshi_select");
    var other = noshi.querySelector(".noshi_other_input");
    var okurinushi = noshi.querySelector(NOSHI_OKURINUSHI);

    return {
      check: noshi.querySelector(".noshi_check_input"),
      omotegaki: omotegaki,
      omotegakiField: omotegaki ? omotegaki.closest(".noshi_field") : null,
      other: other,
      otherField: other ? other.closest(".noshi_field") : null,
      okurinushi: okurinushi,
      okurinushiField: okurinushi ? okurinushi.closest(".noshi_field") : null,
    };
  }

  // 必須項目を列挙（エラーメッセージ付き）
  function getNoshiRequired(p) {
    return [
      { input: p.omotegaki, message: "表書きを選択してください。" },
      { input: p.other, message: "表書きを入力してください。" },
      { input: p.okurinushi, message: "贈り主を入力してください。" },
    ].filter(function (item) {
      return item.input && !item.input.disabled && item.input.required;
    });
  }

  // 1項目分の 表示／有効／必須 をまとめて反映
  // ※非表示の項目に required を残すと送信できなくなるため、必ず表示状態と同期させる
  function setNoshiField(field, input, show, required) {
    if (field) {
      field.hidden = !show;
      field.classList.toggle("is-required", !!(show && required));
    }
    if (!input) return;

    input.disabled = !show;
    input.required = !!(show && required);

    if (!show) {
      input.value = "";
      clearNoshiError(input);
    }
  }

  // チェックOFF時：【包装】【のし】を「なし」に戻す（非表示のまま値が残らないように）
  function resetNoshiBody(noshi) {
    noshi.querySelectorAll(".noshi_radio_input").forEach(function (el) {
      el.checked = el.value === "なし";
    });
  }

  // .noshi の状態を一括同期
  function syncNoshi(noshi) {
    var p = getNoshiParts(noshi);
    if (!p.check) return;

    var on = p.check.checked;

    // ブラウザ標準の検証は切り、独自のエラー表示に統一する
    // ※カート再描画で form 要素が差し替わると消えるため、同期のたびに付け直す
    if (p.check.form) p.check.form.noValidate = true;

    // 全体の開閉
    noshi.classList.toggle("is-open", on);
    p.check.setAttribute("aria-expanded", on);

    // チェックOFFなら【包装】【のし】を「なし」に戻す
    if (!on) resetNoshiBody(noshi);

    // 【包装】【のし】のラジオはチェックON時のみ有効
    noshi.querySelectorAll(".noshi_radio_input").forEach(function (el) {
      el.disabled = !on;
    });

    // 「のし希望」＝ チェックON かつ 【のし】が「なし」以外
    var checkedNoshi = noshi.querySelector(NOSHI_RADIO + ":checked");
    var wantNoshi = on && !!checkedNoshi && checkedNoshi.value !== "なし";

    // 表書きが「その他」かどうか（クリア前に判定）
    var isOther = !!p.omotegaki && p.omotegaki.value === "その他";

    // ① のし希望 → 表書き・贈り主を必須（「その他」選択時は入力欄も必須）
    // ② のし不要 → 表書き・贈り主の欄は非表示＋無効＋値クリア
    setNoshiField(p.omotegakiField, p.omotegaki, wantNoshi, true);
    setNoshiField(p.otherField, p.other, wantNoshi && isOther, true);
    setNoshiField(p.okurinushiField, p.okurinushi, wantNoshi, true);

    updateNoshiGate();
  }

  /* --- エラー表示 --- */

  function getNoshiErrorEl(input, create) {
    var field = input.closest(".noshi_field");
    if (!field) return null;

    var el = field.querySelector(".noshi_error");
    if (!el && create) {
      el = document.createElement("p");
      el.className = "noshi_error";
      field.appendChild(el);
    }
    return el;
  }

  function showNoshiError(input, message) {
    var el = getNoshiErrorEl(input, true);
    if (el) el.textContent = message;
    input.setAttribute("aria-invalid", "true");
  }

  function clearNoshiError(input) {
    var el = getNoshiErrorEl(input, false);
    if (el) el.textContent = "";
    input.removeAttribute("aria-invalid");
  }

  /* --- 送信前の必須チェック --- */

  // 指定フォームに紐づく .noshi を集める（form属性で外付けされているため）
  function getNoshiBlocksForForm(form) {
    var blocks = [];
    document.querySelectorAll(".noshi").forEach(function (noshi) {
      var check = noshi.querySelector(".noshi_check_input");
      if (check && check.form === form) blocks.push(noshi);
    });
    return blocks;
  }

  // 未入力があれば最初の項目を返す（なければ null）
  function validateNoshi(form) {
    var blocks = getNoshiBlocksForForm(form);
    if (!blocks.length) return null;

    // カート再描画などで required / hidden の状態が失われていても正しく判定できるよう、
    // 検証の直前にラジオ・セレクトの選択状態から作り直す
    blocks.forEach(syncNoshi);

    var firstInvalid = null;

    blocks.forEach(function (noshi) {
      getNoshiRequired(getNoshiParts(noshi)).forEach(function (item) {
        if (item.input.value.trim() === "") {
          showNoshiError(item.input, item.message);
          if (!firstInvalid) firstInvalid = item.input;
        } else {
          clearNoshiError(item.input);
        }
      });
    });

    return firstInvalid;
  }

  // 未入力を知らせて該当欄へ移動する
  function reportNoshiInvalid(invalid) {
    invalid.focus({ preventScroll: true });
    if (typeof invalid.scrollIntoView === "function") {
      invalid.scrollIntoView({ block: "center", behavior: "smooth" });
    }
  }

  /* --- アクセラレーテッド決済ボタンの抑止 --- */
  // Shop Pay / Google Pay 等はフォーム送信を経由しないため submit では止められない。
  // 必須項目が未入力のあいだはボタンを操作できないようにする（カートページ用）

  function hasNoshiIncomplete() {
    var incomplete = false;
    document.querySelectorAll(".noshi").forEach(function (noshi) {
      getNoshiRequired(getNoshiParts(noshi)).forEach(function (item) {
        if (item.input.value.trim() === "") incomplete = true;
      });
    });
    return incomplete;
  }

  function updateNoshiGate() {
    var incomplete = hasNoshiIncomplete();

    document.querySelectorAll(".cart__dynamic-checkout-buttons").forEach(function (box) {
      box.classList.toggle("is-noshi-incomplete", incomplete);

      var note = box.querySelector(".noshi_gate_note");
      if (incomplete && !note) {
        note = document.createElement("p");
        note.className = "noshi_gate_note";
        note.textContent = "のし・包装の必須項目をご入力ください。";
        box.insertBefore(note, box.firstChild);
      } else if (!incomplete && note) {
        note.remove();
      }
    });
  }

  /* --- イベント --- */

  // 開閉・表示・必須の同期 ※イベント委譲（カート再描画にも対応）
  document.addEventListener("change", function (e) {
    var noshi = e.target.closest(".noshi");
    if (!noshi) return;
    clearNoshiError(e.target);
    syncNoshi(noshi);
  });

  // 入力したらエラー表示を消す
  document.addEventListener("input", function (e) {
    if (!e.target.closest(".noshi")) return;
    clearNoshiError(e.target);
    updateNoshiGate();
  });

  // 送信前の必須チェック
  // ※ document のキャプチャ段階で、Shopify側の送信処理より先に実行して止める
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    var invalid = validateNoshi(form);
    if (!invalid) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    reportNoshiInvalid(invalid);
  }, true);

  // 送信ボタンのクリックも押さえる
  // ※ Shopify側が form.submit() を直接呼ぶ経路では submit イベントが発火せず、
  //   クリックで直接遷移する実装もあるため、クリック段階でも同じ判定を行う
  var NOSHI_SUBMIT_BTN = [
    '[name="checkout"]',
    '[name="add"]',
    "#checkout",
    ".cart__checkout-button",
    ".product-form__submit",
  ].join(", ");

  document.addEventListener("click", function (e) {
    var btn = e.target.closest(NOSHI_SUBMIT_BTN);
    if (!btn) return;

    var form = btn.form || btn.closest("form");
    if (!form) return;

    var invalid = validateNoshi(form);
    if (!invalid) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    reportNoshiInvalid(invalid);
  }, true);

  // 初期化（novalidate の付与は syncNoshi 側で毎回行う）
  function syncAllNoshi() {
    document.querySelectorAll(".noshi").forEach(syncNoshi);
  }

  syncAllNoshi();

  // カート再描画（数量変更など）で のし欄ごと差し替わったら状態を作り直す
  // ※ .noshi の追加だけを見る。エラー文の書き換えなど自分の変更では動かないようにしている
  if (typeof MutationObserver !== "undefined") {
    new MutationObserver(function (records) {
      var reinserted = records.some(function (r) {
        return Array.prototype.some.call(r.addedNodes, function (n) {
          return n.nodeType === 1 && (n.matches(".noshi") || !!n.querySelector(".noshi"));
        });
      });
      if (reinserted) syncAllNoshi();
    }).observe(document.body, { childList: true, subtree: true });
  }
  
  // 入力したらエラー表示を消す
  document.addEventListener("input", function (e) {
    if (!e.target.closest(".noshi")) return;
    clearNoshiError(e.target);
    updateNoshiGate();
  });

  // 送信前の必須チェック
  // ※ document のキャプチャ段階で、Shopify側の送信処理より先に実行して止める
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    var invalid = validateNoshi(form);
    if (!invalid) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    invalid.focus({ preventScroll: true });
    if (typeof invalid.scrollIntoView === "function") {
      invalid.scrollIntoView({ block: "center", behavior: "smooth" });
    }
  }, true);

  // 初期化
  document.querySelectorAll(".noshi").forEach(function (noshi) {
    // ブラウザ標準の検証は切り、独自のエラー表示に統一する
    // （商品詳細のカート追加フォームは元から novalidate、カートフォームは付いていない）
    var check = noshi.querySelector(".noshi_check_input");
    if (check && check.form) check.form.noValidate = true;

    syncNoshi(noshi);
  });

  // 入力したらエラー表示を消す
  document.addEventListener("input", function (e) {
    if (!e.target.closest(".noshi")) return;
    clearNoshiError(e.target);
  });

  // 送信前の必須チェック
  // ※カート追加フォームは novalidate のためブラウザ標準の検証が働かない。
  //   document のキャプチャ段階で先に止める（Shopify側の送信処理より前に実行される）
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    var invalid = validateNoshi(form);
    if (!invalid) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    invalid.focus({ preventScroll: true });
    if (typeof invalid.scrollIntoView === "function") {
      invalid.scrollIntoView({ block: "center", behavior: "smooth" });
    }
  }, true);

  // 初期化
  document.querySelectorAll(".noshi").forEach(syncNoshi);

});
